// extracted by mini-css-extract-plugin
module.exports = {"NavigationItems":"NavigationItems__NavigationItems__3tGJ9"};